
import {svelteprojectfromproto, protobuffromsvelteproject} from './project';
import {fromProtoTimeStamp, toProtoTimeStamp} from './util';
export default class {
    constructor(deps) {
        this.metadata = deps.getMetadata();
        this.proto = deps.proto;
        this.client = new deps.proto.TaskClient(VITE_APIURL, null, null)
    }

   
     index() {
        const req = new this.proto.TaskRequest()
        return this.client.index(req, this.metadata).then(res => {
            return res.getTaskList().map(task => {
                return this.sveltetaskfromproto(task)
            });
        })
    } 
/*     index() {
        const req = new this.proto.TaskRequest()
        return this.client.index(req, {}).then(res => {
            return res.getTaskList()
        })
    } */
    completed() {
        const req = new this.proto.TaskRequest()
        return this.client.completed(req, this.metadata).then(res => {
            return res.getTaskList()
        })
    } 
    add(data) {
        let req = new this.proto.TaskRequest()
        req.setTask(this.protobuffromsveltetask(data))
        return this.client.add(req, this.metadata).then(res => {
            return this.sveltetaskfromproto(res)
        })
           
        
    }
    update(data) {
        let req = new this.proto.TaskRequest()
        req.setTask(this.protobuffromsveltetask(data))
        return this.client.update(req, this.metadata).then(res => {
                return this.sveltetaskfromproto(res)
            })
        
    }
    sveltetaskfromproto(data) {
        let project = {}
        if (data.getProject()) {
            svelteprojectfromproto(data.getProject())
        }
        console.log(data)
        return {
            id: data.getId(),
            name: data.getName(),
            description: data.getDescription(),
            status: data.getStatus(),
            nextaction: fromProtoTimeStamp(data.getNextaction()),
            updatedAt: data.getUpdatedAt(),
            createdAt: data.getCreatedAt(),
            viewedAt: data.getViewedAt(),
            priority: data.getPriority(),
            project: project,
            
        }
    }
    protobuffromsveltetask(data) {
        let tsk = new proto.proto.Task
        if (tsk.project) {
            tsk.setProject(protobuffromsvelteproject(data.project))
        }
        tsk.setId(data.id)
        tsk.setName(data.name)
        tsk.setDescription(data.description)
        tsk.setStatus(data.status)
        tsk.setPriority(data.priority)
        if (data.nextaction) {
            tsk.setNextaction(toProtoTimeStamp(data.nextaction))
        }
        tsk.setViewedAt(data.viewedAt)
        return tsk
    }
}

